module.exports = __webpack_public_path__ + "img/patent3.84dd4777.jpg";